import {Injectable} from '@angular/core';
import {
    ApiArticlesGetAllowedValues,
    ApiArticlesGetRequestParams,
    ApiArticlesGetRequestParamsFactory
} from '@api/articles';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import {ApiConfig, ApiConfigsGetRequest, ApiConfigsGetResponse} from '@api/configs';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Observable, combineLatest} from 'rxjs';
import {EnvironmentService} from '@iw-shop/core//services/environment.service';
import {ArticleFilter} from '@iw-shop/article/interfaces/filter';
import {getSelectedCustomer} from "@store/selectors/user.selector";

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private httpWithoutInterceptor: HttpClient;

    constructor(private http: HttpClient, private handler: HttpBackend, private store: Store<AppState>, private environmentService: EnvironmentService) {
        this.httpWithoutInterceptor = new HttpClient(this.handler);
    }

    loadConfig(): Observable<ApiConfigsGetResponse> {

        const body: ApiConfigsGetRequest = {
            id: 'loadConfig',
            command: 'configs/get',
            params: {
                filters: [{fields: ['type'], values: ['live']}],
                configs: {}
            }
        };
        //console.log('configService', this.environmentService.environment.urlApi);
        return this.http.post<ApiConfigsGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }

    getTaxRate(): number {
        let taxRate: number = 0;
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.articleAvailabilities) {
                        taxRate = c.taxRate;
                    }
                }
            );
        return taxRate;
    }

    getDepositTaxRate(): number {
        let depositTaxRate = 0;
        let customerPriceGroup = '';
        this.store.select(getSelectedCustomer).pipe(take(1)).subscribe(r => {
            if (r?.priceGroup) {
                customerPriceGroup = r.priceGroup;
            }
        })
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (customerPriceGroup == '') {
                        customerPriceGroup = c.defaultPriceGroup;
                    }
                    if (c.depositTaxRate) {
                        depositTaxRate = c.depositTaxRate
                    }
                    if (c.depositTaxRateExceptions &&
                        c.depositTaxRateExceptions.priceGroups.includes(customerPriceGroup)) {
                        depositTaxRate = 0;
                    }
                }
            );
        return depositTaxRate;
    }

    getSEO(type: 'default' | 'groups' | 'articles'): { title: string, description: string, keywords: string } {
        let SEO: { title: string, description: string, keywords: string } = {title: '', description: '', keywords: ''};
        this.store.select(state => state.config.SEO)
            .pipe(
                take(1)
            )
            .subscribe(
                r => {
                    SEO = r[type];
                }
            );
        return SEO;
    }

    /*
      setSEOTags(page: string, param?: string): void {
        let seo: { title: string, description: string, keywords: string } = {
          title: '',
          description: '',
          keywords: ''
        };
        switch (page) {
          case 'article-list':
            seo.title = param + ' in unserem Online-Shop';
            seo.description = 'Bestellen Sie Produkte der Kategorie ' + param + ' einfach und bequem in unserem Online-Shop.';
            break;

          case 'article-detail':
            seo.title = param || '';
            seo.description = 'Finden Sie ' + param + ' in unserem Online-Shop.';
            break;

          default:
            seo.title = '';
            seo.description = '';
            break;
        }

        this.store.dispatch(SEOTags({title: seo.title, description: seo.description, keywords: seo.keywords}));
        this.titleService.setTitle(seo.title);
        this.metaService.updateTag({name: 'description', content: seo.description});
        this.metaService.updateTag({name: 'keywords', content: seo.keywords});

      }
    */

    getCustomerId(): string | null {
        let customerId = null;
        this.store.select(getSelectedCustomer)
            .pipe(
                take(1)
            )
            .subscribe(
                r => {
                    if (r?.id) {
                        customerId = r.id;
                    }
                }
            )
        return customerId;
    }

    getEmailAddressesForOrderConfirmation(type: 'order' | 'request'): string[] {
        let recipients: string[] = [];
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.orderEmailSettings) {
                        recipients = c.orderEmailSettings.filter(s => s.orderType == type)[0].recipients.map(r => {
                            return r.email
                        });
                    }
                }
            );
        return recipients;
    }

    getArticleTemplate(): 'gallery' | 'list' {
        let template: 'gallery' | 'list' | null = null;
        combineLatest([this.store.select(state => state.config), this.store.select(state => state.storage)])
            .pipe(
                take(1)
            ).subscribe(
            {
                next: ([config, storage]) => {
                    if (config.defaultArticleTemplate) {
                        template = config.defaultArticleTemplate;
                    }
                    if (storage.articleTemplate) {
                        template = storage.articleTemplate;
                    }
                }
            }
        );
        if (template) {
            return template;
        } else {
            return 'gallery';
        }
    }

    getDefaultSortArticle(scope: 'default' | 'novelties' | 'offers'): string {
        let value: string = '';
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.sortArticle[scope]) {
                        value = c.sortArticle[scope];
                    }
                }
            );
        return value;
    }

    getDefaultSortGroup(scope: 'default'): string {
        let value: string = '';
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.sortGroup &&
                        c.sortGroup[scope]) {
                        value = c.sortGroup[scope];
                    }
                }
            );
        return value;
    }

    getDefaultSortGroup1(scope: 'default'): string {
        let value: string = '';
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.sortGroup1[scope]) {
                        value = c.sortGroup1[scope];
                    }
                }
            );
        return value;
    }

    getAvailabilities(): ApiConfig['articleAvailabilities'] {
        let availabilities: ApiConfig['articleAvailabilities'] = [];
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.articleAvailabilities) {
                        availabilities = c.articleAvailabilities;
                    }
                }
            );
        return availabilities;
    }

    getArticleListSort(): ApiConfig['sortArticleList'] {
        let sortArticleList: ApiConfig['sortArticleList'] = [];
        this.store.select(state => state.config)
            .pipe(
                take(1)
            )
            .subscribe(
                c => {
                    if (c.sortArticleList) {
                        sortArticleList = c.sortArticleList;
                    }
                }
            );
        return sortArticleList;
    }

    getArticleSearchInFields(): ApiConfig['articleSearchInFields'] {
        let values: ApiConfig['articleSearchInFields'] = [];
        this.store.select(state => state.config)
            .pipe(take(1))
            .subscribe(
                c => {
                    if (c.articleSearchInFields) {
                        values = c.articleSearchInFields;
                    }
                }
            )
        return values;
    }

    getArticleListFilters(): ArticleFilter[] {
        let filters: ArticleFilter[] = [];
        this.store.select(state => state.config)
            .pipe(take(1))
            .subscribe(c => {
                if (c.articleListAvailableFilters) {
                    filters = c.articleListAvailableFilters
                }
            })
        return filters;
    }

    getVisibilityGroups(): string[] {
        let visibilityGroups: string[] = [];

        combineLatest([
            this.store.select(state => state.config),
            this.store.select(getSelectedCustomer),
            this.store.select(state => state.storage)
        ])
            .pipe(take(1))
            .subscribe(([config, customer, storage]) => {
                if (config?.defaultVisibilityGroups) {
                    visibilityGroups = config.defaultVisibilityGroups;
                }
                if (storage.customer?.id) {
                    visibilityGroups = [];
                    if (customer?.visibilityGroups &&
                        customer.visibilityGroups.length > 0) {
                        visibilityGroups = customer.visibilityGroups;
                    }
                }
            });
        return visibilityGroups;
    }

    isGroupByRelatedGroups(): boolean {
        let value = false;
        this.store.select(state => state.config.articleGroupByRelatedArticleGroup)
            .pipe(take(1))
            .subscribe(
                r => {
                    if (r) {
                        value = r;
                    }
                }
            );
        return value;
    }

    getChangePriceGroupTo(): string | undefined {
        let value = undefined;
        this.store.select(state => state.config.changePriceGroupTo)
            .pipe(take(1))
            .subscribe(
                r => {
                    if (r) {
                        value = r;
                    }
                }
            );
        return value;
    }

    getDefaultArticleListRequestParams(data?: Partial<ApiArticlesGetRequestParams>): ApiArticlesGetRequestParams {
        let dataCopy = data ? {...data} : {};
        let defaultParams: ApiArticlesGetRequestParams = {
            filters: undefined,
            articles: {
                start: dataCopy?.articles?.start || 0,
                limit: dataCopy?.articles?.limit || 50,

                expectedData: {
                    images: 1,
                    name: 1,
                    bestPrice: 1,
                    bestPrices: 1,
                    taxRate: 1,
                    articleNumber: 1,
                    availability: 1,
                    inventory: 1,
                    unit: 1,
                    unitOfMeasurement: 1,
                    unitAddition: 1,
                    unitType: 1,
                    quantity: 1,
                    quantityAddition: 1,
                    packageType: 1,
                    notifications: 1,
                    allergenIngredients: 1,
                    additives: 1,
                    alcoholicStrength: 1,
                    caffeine: 1,
                    relatedArticleGroup: 1,
                    relatedArticleGroupPos: 1
                }
            }
        };

        if (this.getChangePriceGroupTo()) {
            defaultParams.priceGroups = [(this.getChangePriceGroupTo() as string)];
        } else {
            defaultParams.priceGroups = undefined;
        }

        if (dataCopy?.priceGroups) {
            dataCopy.priceGroups = defaultParams.priceGroups;
        } else if (dataCopy) {
            dataCopy.priceGroups = defaultParams.priceGroups;
        }

        this.getArticleListFilters().map(
            f => {
                defaultParams[f.responseName] = {};
            }
        )


        if (this.getVisibilityGroups().length > 0 &&
            dataCopy?.filters) {
            dataCopy.filters = dataCopy.filters?.filter(f => f.field == 'visibilityGroups');
            dataCopy.filters.push({
                field: 'visibilityGroups',
                value: "^(" + this.getVisibilityGroups().join('|') + ")$",
                useRegex: 1
            });

        } else {
            if (this.getVisibilityGroups().length > 0 &&
                dataCopy) {
                dataCopy = {
                    ...dataCopy,
                    filters: [{
                        field: 'visibilityGroups',
                        value: "^(" + this.getVisibilityGroups().join('|') + ")$",
                        useRegex: 1
                    }]
                };
            }
        }
        if (defaultParams.articles &&
            this.isGroupByRelatedGroups()) {
            defaultParams.articles.groupBy = {field: "relatedArticleGroup"};
        }

        if (dataCopy?.articles) {
            dataCopy.articles = {...defaultParams.articles, ...dataCopy.articles};
        } else {
            dataCopy = {...dataCopy, articles: defaultParams.articles}
        }


        if (this.getDefaultSortArticle('default').length > 0) {
            this.getArticleListSort().map(r => {
                if (r.nameInternal == this.getDefaultSortArticle('default') &&
                    dataCopy?.articles) {
                    switch (r.type) {
                        case 'sort':
                            dataCopy.articles.sort = [{field: r.field, direction: r.direction}];
                            break;

                        case 'sortIndividual':
                            dataCopy.articles.sortIndividual = this.getDefaultSortArticle('default');
                            break;

                        case 'sortArticlePrice':
                            dataCopy.articles.sortArticlePrice = {
                                direction: r.direction,
                                fromArticleQuantity: 1,
                                fromCartQuantity: 1
                            };
                            break;

                    }
                }
            })

        }

        if (this.getDefaultSortGroup1('default').length > 0) {
            defaultParams.groups1 = {
                sortIndividual: this.getDefaultSortGroup1('default')
            }
        }

        const customerId = this.getCustomerId();
        if (customerId) {
            defaultParams.customerId = customerId;
        }
        let x = ApiArticlesGetRequestParamsFactory.create({...defaultParams, ...dataCopy});
        return ApiArticlesGetRequestParamsFactory.create({...defaultParams, ...dataCopy});
    }

    getRedirectRouterLinkAfterLogin(): string {
        let routerLink = '';
        this.store.select(state => state.config).pipe(
            take(1)
        )
            .subscribe(
                r => {
                    if (r.redirectRouterLinkAfterLogin) {
                        routerLink = r.redirectRouterLinkAfterLogin;
                    }
                }
            )
        return routerLink;
    }

    getArticleShowPricePerUnit(): boolean {
        let articleShowPricePerUnit: boolean = false;
        this.store.select(state => state.config).pipe(
            take(1)
        )
            .subscribe(
                r => {
                    if (r.articleShowPricePerUnit) {
                        articleShowPricePerUnit = r.articleShowPricePerUnit;
                    }
                }
            )
        return articleShowPricePerUnit;

    }

    getDefaultArticleDetailsRequestParams(data?: {
        filters?: {
            field: ApiArticlesGetAllowedValues['filterFields'],
            value: string | boolean,
            useRegex?: 0 | 1
        }[], articles?: { customerId?: string }
    }): ApiArticlesGetRequestParams {
        let defaultParams: ApiArticlesGetRequestParams = {
            filters: data?.filters || [],
            articles: {
                expectedData: {
                    name: 1,
                    articleNumber: 1,
                    images: 1,
                    quantity: 1,
                    unit: 1,
                    unitAddition: 1,
                    unitType: 1,
                    taxRate: 1,
                    groups: 1,
                    bestPrice: 1,
                    bestPrices: 1,
                    inventory: 1,
                    availability: 1,
                    eans: 1,
                    packageType: 1,
                    depositPackageType: 1,
                    quantityAddition: 1,
                    unitOfMeasurement: 1,
                    totalWeightInKg: 1,
                    brand: 1,
                    manufacturer: 1,
                    manufacturerCompanyAddress: 1,
                    manufacturerInternetAddress: 1,
                    distributor: 1,
                    country: 1,
                    description: 1,
                    additionalData: 1,
                    region: 1,
                    relatedArticleGroup: 1,
                    minimumDurability: 1,
                    salesDescription: 1,
                    manufacturingLocation: 1,
                    certificates: 1,
                    alcoholicStrength: 1,
                    caffeine: 1,
                    foodDirectory: 1,
                    additives: 1,
                    allergenIngredients: 1,
                    energyInKilojoule: 1,
                    energyInKilokalorie: 1,
                    protein: 1,
                    carbohydrates: 1,
                    fatRate: 1,
                    sugar: 1,
                    saturatedFattyAcids: 1,
                    dietaryFibers: 1,
                    natrium: 1,
                    salt: 1,
                    category: 1,
                    variety: 1,
                    flavor: 1,
                    quality: 1,
                    colorNuance: 1,
                    drinkingTemperature: 1,
                    acid: 1,
                    shelfLife: 1,
                    recommendation: 1,
                    recommendationFilter: 1,
                    characteristics: 1,
                    soilType: 1,
                    vinification: 1,
                    scent: 1,
                    residualSugar: 1,
                    flavorDescriptionShort: 1,
                    flavorDescriptionLong: 1,
                    flavorDescriptionLong2: 1,
                    conclusion: 1,
                    growerInfo: 1,
                    wineDescription: 1,
                    wineType: 1,
                    vitamins: 1,
                    considerQuantityInCart: 1,
                    visibilityGroups: 1,
                    notifications: 1,
                    SEO: 1,
                }
            }
        };

        if (defaultParams.articles &&
            data?.articles?.customerId) {
            defaultParams.customerId = data.articles.customerId;
        }

        const customerId = this.getCustomerId();
        if (customerId) {
            defaultParams.customerId = customerId;
        }

        if (data?.filters) {
            defaultParams.filters = data.filters;
            if (this.getVisibilityGroups().length > 0) {
                defaultParams.filters?.push({
                    field: 'visibilityGroups',
                    value: "^(" + this.getVisibilityGroups().join('|') + ")$",
                    useRegex: 1
                });
            }
        } else {
            if (this.getVisibilityGroups().length > 0) {
                defaultParams.filters = [{
                    field: 'visibilityGroups',
                    value: "^(" + this.getVisibilityGroups().join('|') + ")$",
                    useRegex: 1
                }];
            }
        }
        let x = ApiArticlesGetRequestParamsFactory.create(defaultParams);
        return ApiArticlesGetRequestParamsFactory.create(defaultParams);
    }
}
